import { render } from "./CircleStencil.vue?vue&type=template&id=a08566f4"
import script from "./CircleStencil.vue?vue&type=script&lang=js"
export * from "./CircleStencil.vue?vue&type=script&lang=js"

import "./CircleStencil.vue?vue&type=style&index=0&id=a08566f4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__